// extracted by mini-css-extract-plugin
module.exports = {"box":"search-box_box__21KLH","input":"search-box_input__O24HG","row":"search-box_row__2g6x4","submit":"search-box_submit__2G3Ri"};